import React, { useContext, useEffect, useState } from "react";
import { Segmented } from "antd";
import { Modal } from "react-bootstrap";
import { popupcontext } from "../../../../context/Popupscontext";
import { getData } from "../../../../utils/IndexedDB";
import Popup from "../../../Helpers/Popup/Popup";
import PopupTitle from "../../../Helpers/Popup/PopupParts/PopupTitle";
import Close from "../../../Helpers/CloseBtn/Close";
import SnagOfflineInf from "./SnagOfflineInf";
import SnagOfflineData from "./SnagOfflineData";

export default function SnagOfflinePopup() {
	const { offlinePopup, setOfflinePopup, currentSnagId, setcurrentSnagId } =
		useContext(popupcontext);
	const [formEditData, setFormEditData] = useState(null);
	const [segment, setSegment] = useState("Information");

	useEffect(() => {
		const initDB = async () => {
			try {
				if (currentSnagId) {
					const snagData = await getData(
						"OfflineModeData",
						"Snag",
						currentSnagId,
					);
					setFormEditData(snagData);
				}
			} catch (error) {
				console.error("IndexedDB read error:", error);
			}
		};

		initDB();
	}, [currentSnagId]);
	return (
		<Popup show={offlinePopup && currentSnagId}>
			<Modal.Header className="modal-header flex-between">
				<Modal.Title id="contained-modal-title-vcenter">
					<PopupTitle headtitle={`${formEditData?.id}`} />
				</Modal.Title>
				<Close
					// eslint-disable-next-line react/style-prop-object
					style="close-32 close"
					close={() => {
						setOfflinePopup(false);
						setFormEditData(null);
						setcurrentSnagId(null);
					}}
					img="Close"
				/>
			</Modal.Header>
			<Segmented
				options={["Information", "Snags"]}
				value={segment}
				onChange={(value) => setSegment(value)}
				block
			/>
			{formEditData && (
				<Modal.Body className="modal-body-scrollable">
					{segment === "Information" && (
						<SnagOfflineInf formEditData={formEditData} />
					)}
					{segment === "Snags" && (
						<SnagOfflineData formEditData={formEditData} />
					)}
				</Modal.Body>
			)}
		</Popup>
	);
}
